module.exports = __webpack_public_path__ + "img/Mask Group 2.07b23398.png";